// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'payment-detail',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-payment-details/team-member-payment-details/[id].vue'),
        name: 'human-resource.team-member-payment-details.view-team-member-payment-detail',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-payment-details.get-team-member-payment-detail',
        },
    },
    {
        path: 'payment-detail/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payment-details" */ '@/pages/[organisation]/hr/team-member-payment-details/team-member-payment-detail/[id]/edit.vue'),
        name: 'human-resource.team-member-payment-details.edit-team-member-payment-detail',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-payment-details.upsert-team-member-payment-detail',
        },
    },
];
